<template>
  <div class="content-wrapper">
    <ContentHeader title="Топливные карты" />
    <div class="content-body">
      <!-- Карт-счета  -->
      <div class="row">
        <div class="col-xs-12" ref="caSelector">
          <card
            headerTitle="Выберите карт-счёт"
            :busy="isCardsAccsLoading"
            hideFooter
            @reload="reloadCardsAccs"
          >
            <template slot="block">
              <button
                class="
                  btn btn-success btn-min-width
                  mx-1
                  mb-1
                  bg-yellow bg-darken-2
                "
                :class="{
                  'active bg-darken-3': !currentAcc,
                  'btn-hover': !!currentAcc,
                }"
                :aria-pressed="!currentAcc"
                @click="
                  $router.replace({ query: {} });
                  $refs.caSelector.scrollIntoView({ behavior: 'smooth' });
                "
              >
                Все карты
              </button>
              <button
                v-for="ca in getCardsAccsNotRemoved"
                :key="ca.id"
                class="
                  btn btn-success btn-min-width
                  mx-1
                  mb-1
                  bg-blue bg-darken-2
                "
                :class="{
                  'active bg-darken-4': currentAcc == ca.id,
                  'btn-hover': !(currentAcc == ca.id),
                }"
                :aria-pressed="currentAcc == ca.id"
                @click="
                  $router.replace({ query: { acc: ca.id } });
                  $refs.caSelector.scrollIntoView({ behavior: 'smooth' });
                "
              >
                {{ ca.name }}
              </button>
              <button
                v-if="isCardAccsCreationEnabled"
                class="
                  btn btn-success btn-min-width
                  mx-1
                  mb-1
                  bg-green bg-darken-3
                  btn-hover
                "
                @click="showNewAccModal = true"
              >
                <i class="icon-plus" style="padding-right: 15px"></i>
                Создать карт-счёт
              </button>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <!-- Нераспределённый объём -->
        <div class="col-xs-12 col-md-6" v-if="!currentAcc">
          <card
            headerTitle="Нераспределённый объём"
            :busy="isCardsClientBalanceLoading"
            hideFooter
            @reload="reloadClientBalance"
          >
            <template slot="block">
              <div style="margin-bottom: 40px">
                <div class="float-xl-right float-sm-none mb-1">
                  <button
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    @click="showFuelModal = true"
                  >
                    <i class="icon-cart4" style="padding-right: 15px"></i>
                    Пополнить
                  </button>
                  <!--button
                    v-if="getCardsAccsNotRemoved.length > 0"
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    :disabled="getClientFuelBalance.length == 0"
                    @click="showFuelAccToAccModal = true"
                  >
                    <i
                      class="icon-arrow-return-right"
                      style="padding-right: 15px"
                    ></i>
                    Перевести
                  </button-->
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Остатки в литрах на текущий момент, не распределённые по
                    карт-счетам.
                  </p>
                </div>
              </div>
              <b-table-simple
                show-empty
                hover
                bordered
                :busy="isCardsClientBalanceLoading"
              >
                <b-thead class="bg-grey bg-lighten-2">
                  <b-th>Тип топлива</b-th>
                  <b-th>Цена</b-th>
                  <b-th>Остаток, литры</b-th>
                </b-thead>
                <b-tbody>
                  <b-tr v-if="isCardsClientBalanceFailed">
                    <b-td colspan="3"
                      >Ошибка подключения. Попробуйте позже</b-td
                    >
                  </b-tr>
                  <b-tr v-else-if="getClientFuelBalance.length == 0">
                    <b-td colspan="3">Записи отсутствуют</b-td>
                  </b-tr>
                  <template v-else v-for="f in getClientFuelBalance">
                    <template v-for="(p, index) in f.values">
                      <b-tr :key="f.product_name + p.price">
                        <b-td v-if="index == 0" :rowspan="f.values.length">{{
                          f.product_name
                        }}</b-td>
                        <b-td>{{ p.price }}</b-td>
                        <b-td>
                          <value-tag :value="p.quantity" />
                        </b-td>
                      </b-tr>
                    </template>
                  </template>
                </b-tbody>
              </b-table-simple>
            </template>
          </card>
        </div>

        <!-- Нераспределённые денежные средства -->
        <div class="col-xs-12 col-md-6" v-if="!currentAcc">
          <card
            headerTitle="Нераспределённые денежные средства"
            :busy="isCardsClientBalanceLoading"
            hideFooter
            @reload="reloadClientBalance"
          >
            <template slot="block">
              <div style="margin-bottom: 40px">
                <div class="float-xl-right float-sm-none mt10">
                  <button
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    @click="showMoneyModal = true"
                  >
                    <i class="icon-cart4" style="padding-right: 15px"></i>
                    Пополнить
                  </button>
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Остаток денежных средств, не распределённых по карт-счетам.
                  </p>
                </div>
              </div>
              <b-table-simple
                show-empty
                hover
                bordered
                :busy="isCardsClientBalanceLoading"
              >
                <b-thead class="bg-grey bg-lighten-2">
                  <b-th>Валюта</b-th>
                  <b-th>Остаток</b-th>
                </b-thead>
                <b-tbody>
                  <b-tr v-if="isCardsClientBalanceFailed">
                    <b-td colspan="2"
                      >Ошибка подключения. Попробуйте позже</b-td
                    >
                  </b-tr>
                  <b-tr>
                    <b-td>Тенге</b-td>
                    <b-td><value-tag :value="getClientMoneyBalance" /></b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </template>
          </card>
        </div>

        <!-- Остаток на литровом балансе -->
        <div class="col-xs-12 col-md-6" v-if="currentAcc" ref="fuelBalanceCard">
          <card
            headerTitle="Остаток на литровом балансе"
            :busy="isCardsBalanceLoading"
            hideFooter
            @reload="reloadBalances"
          >
            <template slot="block">
              <div style="margin-bottom: 40px">
                <div class="float-xl-right float-sm-none mb-1">
                  <button
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    @click="showFuelToAccModal = true"
                  >
                    <i class="icon-cart4" style="padding-right: 15px"></i>
                    Пополнить
                  </button>
                  <button
                    v-if="getCardsAccsNotRemoved.length > 1"
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    :disabled="getCardAccFuelBalance(currentAcc).length == 0"
                    @click="showFuelAccToAccModal = true"
                  >
                    <i
                      class="icon-arrow-return-right"
                      style="padding-right: 15px"
                    ></i>
                    Перевести
                  </button>
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Остатки в литрах на текущий момент по карт-счёту «{{
                      getCardAccName(currentAcc)
                    }}».
                  </p>
                </div>
              </div>
              <b-table-simple
                show-empty
                hover
                bordered
                :busy="isCardsBalanceLoading"
              >
                <b-thead class="bg-grey bg-lighten-2">
                  <b-th>Тип топлива</b-th>
                  <b-th>Цена</b-th>
                  <b-th>Остаток, литры</b-th>
                </b-thead>
                <b-tbody>
                  <b-tr v-if="isCardsBalanceFailed">
                    <b-td colspan="3"
                      >Ошибка подключения. Попробуйте позже</b-td
                    >
                  </b-tr>
                  <b-tr v-else-if="isCardAccFuelEmpty(currentAcc)">
                    <b-td colspan="3">Средства отсутствуют</b-td>
                  </b-tr>
                  <template
                    v-else
                    v-for="f in getCardAccFuelBalance(currentAcc)"
                  >
                    <template v-for="(p, index) in f.price">
                      <b-tr  :key="p">
                        <b-td v-if="index == 0" :rowspan="f.price.length">{{
                          f.name
                        }}</b-td>
                        <b-td>{{ p }}</b-td>
                        <b-td>
                          <value-tag :value="f.quantity[index]" />
                        </b-td>
                      </b-tr>
                    </template>
                  </template>
                </b-tbody>
              </b-table-simple>
            </template>
          </card>
        </div>

        <!-- Остаток на денежном балансе -->
        <div class="col-xs-12 col-md-6" v-if="currentAcc">
          <card
            headerTitle="Остаток на денежном балансе"
            :busy="isCardsBalanceLoading"
            hideFooter
            @reload="reloadBalances"
          >
            <template slot="block">
              <div style="margin-bottom: 40px">
                <div class="float-xl-right float-sm-none mb-1">
                  <button
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    @click="showMoneyToAccModal = true"
                  >
                    <i class="icon-cart4" style="padding-right: 15px"></i>
                    Пополнить
                  </button>
                  <button
                    v-if="getCardsAccsNotRemoved.length > 1"
                    class="
                      btn btn-success btn-block btn-min-width
                      bg-green bg-darken-3
                      btn-hover
                    "
                    :disabled="getCardAccMoneyBalance(currentAcc) == 0"
                    @click="showMoneyAccToAccModal = true"
                  >
                    <i
                      class="icon-arrow-return-right"
                      style="padding-right: 15px"
                    ></i>
                    Перевести
                  </button>
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Остаток денежных средств на текущий момент по карт-счёту «{{
                      getCardAccName(currentAcc)
                    }}».
                  </p>
                </div>
              </div>
              <b-table-simple
                show-empty
                hover
                bordered
                :busy="isCardsBalanceLoading"
              >
                <b-thead class="bg-grey bg-lighten-2">
                  <b-th>Валюта</b-th>
                  <b-th>Остаток</b-th>
                </b-thead>
                <b-tbody>
                  <b-tr v-if="isCardsClientBalanceFailed">
                    <b-td colspan="2"
                      >Ошибка подключения. Попробуйте позже</b-td
                    >
                  </b-tr>
                  <b-tr>
                    <b-td>Тенге</b-td>
                    <b-td
                      ><value-tag :value="getCardAccMoneyBalance(currentAcc)"
                    /></b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <!-- Список карт -->
        <div class="col-xs-12">
          <BillTable
            :title="
              'Список карт' +
              (currentAcc ? ` «${getCardAccName(currentAcc)}»` : '')
            "
            :fields="cardsFields"
            :items="getCards(currentAcc)"
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"
            :busy="isCardsLoading"
            :failed="isCardsFailed"
            @reload="reloadCards"
          >
            <template slot="top">
              <div class="card-block">
                <div class="form-group float-xl-right float-sm-none mt10">
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="timesheetinput1"
                      class="form-control bg-grey bg-lighten-4"
                      placeholder="Поиск по списку карт"
                      name="tablesearch"
                      v-model="filter"
                    />
                    <div class="form-control-position">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <p style="padding-left: 10px">
                    Общее количество топливных карт - {{ getCardsCount }} /
                    Активных - {{ getActiveCardsCount }} / Заблокированных -
                    {{ getBlockedCardsCount }} <br />
                    <template v-if="currentAcc"
                      >Далее отображены карты привязанные к карт-счёту «{{
                        getCardAccName(currentAcc)
                      }}»</template
                    >
                    <br />* - Лимиты указываются в следующем порядке:
                    <em>Суточный / Недельный / Месячный / Кол-во операций</em>
                  </p>
                </div>
              </div>
              <div class="card-block">
                <div class="float-xl-left float-sm-none mt10">
                  <router-link
                    to="cards/details"
                    class="btn btn-info btn-block btn-min-width"
                  >
                    <i class="icon-file-text2" style="padding-right: 15px"></i>
                    Детализация по картам
                  </router-link>
                </div>
                <div class="float-xl-left float-sm-none mt10">
                  <!--button href="#" class="btn btn-secondary btn-min-width" style=" margin-left: 10px;">
                    <i class="icon-download4"></i> Скачать список карт в формате .xlsх
                  </button-->
                </div>
                <div class="float-xl-right float-sm-none mt10">
                  <button
                    href="#"
                    class="
                      btn btn-info btn-block btn-min-width
                      bg-blue bg-darken-2
                      btn-hover
                    "
                    data-toggle="modal"
                    data-keyboard="false"
                    data-target="#inlineForm-2"
                    @click="showCardModal = true"
                  >
                    <i class="icon-credit-card" style="padding-right: 15px"></i>
                    Заказать карты
                  </button>
                </div>
                <div
                  class="float-xl-right float-sm-none mt10"
                  style="margin-left: 10px"
                ></div>
                <div class="float-xl-right float-sm-none mt10">
                  <button
                    href="#"
                    class="
                      btn btn-info btn-block btn-min-width
                      bg-blue bg-accent-2
                      btn-hover
                    "
                    data-toggle="modal"
                    data-keyboard="false"
                    data-target="#inlineForm-1"
                    @click="showTrinketModal = true"
                  >
                    <i class="icon-key22" style="padding-right: 15px"></i>
                    Заказать брелки
                  </button>
                </div>
              </div>
            </template>
            <template v-slot:cell(status)="data">
              <span
                class="tag tag-default"
                :class="{
                  'bg-warning bg-red bg-darken-2':
                    data.value === 'Заблокирована',
                  'bg-green bg-darken-1': data.value === 'Активна',
                }"
                >{{ data.value }}</span
              >
            </template>
            <template v-slot:cell(card_user_login)="row">
              <span
                v-if="row.item.card_user_id != null" 
                class="btn-link" 
                @click="showDriverCabinetModal( row.item.id, row.item.card_user_id )"
                >{{ row.item.card_user_login }}</span
              >
            </template>
            <template v-slot:cell(actions)="row">
              <div class="text-xs-center">
                <component
                  :is="row.item.block ? 'span' : 'router-link'"
                  :to="'/cards/' + row.item.id"
                  class="btn-link"
                  title="Редактировать"
                  style="cursor: pointer"
                  :class="{ 'text-muted': row.item.block }"
                  :disabled="row.item.block"
                >
                  <i
                    class="icon-cog3 font-medium-5"
                    :class="{ ' icon-hover indigo': !row.item.block }"
                  ></i>
                </component>
                <button
                  class="btn-link"
                  :class="{ 'text-muted': row.item.block }"
                  :title="row.item.block ? 'Разблокировать' : 'Заблокировать'"
                  style="cursor: pointer"
                  @click="
                    cardToBlockId = row.item.id;
                    row.item.block
                      ? (showUnblockModal = true)
                      : (showBlockModal = true);                      
                  "
                >
                  <i
                    :class="{ 'icon-unlock2': row.item.block }"
                    class="icon-lock4 font-medium-5 icon-hover indigo"
                  ></i>
                </button>
                <button
                  class="btn-link"
                  :class="{ 'text-muted': row.item.block }"
                  :title="'Создать кабинет'"
                  style="cursor: pointer"
                  v-if="row.item.card_user_id==null"
                  @click=" showConfirmNewCabinetModal( row.item.id, row.item.card_user_id );"
                >
                  <i
                    :class="'icon-profile'"
                    class="icon-lock4 font-medium-5 icon-hover indigo"
                  ></i>
                </button>
              </div>
            </template>
          </BillTable>
        </div>
      </div>
      <!-- Пополнение топливного баланса -->
      <modal
        :id="fuelModalId"
        v-if="showFuelModal"
        @close="closeFuelModal"
        @cancel="closeFuelModal"
        @ok="requestFuelBalance"
      >
        <template slot="header-title">Пополнить литровый баланс</template>
        <template slot="body">
          <p>{{ modalCaption }}</p>
          <label>Объём, литры:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите объём"
              class="form-control"
              style="background: #effbee"
              min="0"
              max="999999999"
              @input="validateFuelModal"
              v-model="fuelRequestQuantity"
            />
            <error-p :error="fuelModalError" />
          </div>
        </template>
        <template slot="ok-title">Создать заявку</template>
      </modal>
      <!-- Пополнить топливный баланс картсчёта -->
      <modal
        :id="fuelToAccModalId"
        v-if="showFuelToAccModal"
        @close="closeFuelToAccModal"
        @cancel="closeFuelToAccModal"
        @ok="transferFuelToAcc"
      >
        <template slot="header-title"
          >Пополнить литровый баланс карт-счёта</template
        >
        <template slot="body">
          <p>{{ fuelToAccCaption }}</p>
          <label>Топливо:</label>
          <div class="form-group">
            <select
              v-model="productToTransfer"
              class="form-control"
              style="background: #effbee"
              @change="
                if (priceToTransfer != null) {
                  priceToTransfer = null;
                  validatePriceToTransfer();
                }
                productToTransferError = null;
              "
            >
              <option :value="null" disabled selected hidden>
                Выберите топливо
              </option>
              <option
                v-for="fb in getClientFuelBalance"
                :key="fb.product_id"
                :value="fb.product_id"
              >
                {{ fb.product_name }}
              </option>
            </select>
            <error-p :error="productToTransferError" />
          </div>

          <label>Цена:</label>
          <div class="form-group">
            <select
              v-model="priceToTransfer"
              class="form-control"
              style="background: #effbee"
              :disabled="productToTransfer == null"
              @change="priceToTransferError = null"
            >
              <option :value="null" disabled selected hidden>
                Выберите цену
              </option>
              <option
                v-for="p in getClientFuelPrices(productToTransfer)"
                :key="p.price"
                :value="p.price"
              >
                {{ p.price }}
              </option>
            </select>
            <error-p :error="priceToTransferError" />
          </div>

          <label>Объём, литры:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите объём"
              class="form-control"
              style="background: #effbee"
              :max="
                getClientFuelQuantityByPrice(productToTransfer, priceToTransfer)
              "
              min="0"
              :disabled="productToTransfer == null || priceToTransfer == null"
              @input="validateFuelToAccModal"
              v-model="fuelRequestQuantity"
            />
            <error-p :error="fuelRequestQuantityError" />
          </div>
          <label
            >Доступно:
            {{
              getClientFuelQuantityByPrice(productToTransfer, priceToTransfer)
            }}
            л.</label
          >
        </template>
        <template slot="ok-title">Пополнить</template>
      </modal>
      <!-- Перевод с топливного баланса картсчёта -->
      <modal
        :id="fuelAccToAccModalId"
        v-if="showFuelAccToAccModal"
        @close="closeFuelAccToAccModal"
        @cancel="closeFuelAccToAccModal"
        @ok="transferFuelAccToAcc"
      >
        <template slot="header-title"
          >Перевести с литрового баланса карт-счёта</template
        >
        <template slot="body">
          <p>{{ fuelAccToAccCaption }}</p>
          <label>Целевой счёт:</label>
          <div class="form-group">
            <select
              v-model="toAccId"
              class="form-control"
              style="background: #effbee"
              @change="toAccIdError = null"
            >
              <option :value="null" disabled selected hidden>
                Выберите счёт
              </option>
              <option v-for="ca in getOtherAccs" :key="ca.id" :value="ca.id">
                {{ ca.name }}
              </option>
            </select>
            <error-p :error="toAccIdError" />
          </div>
          <label>Топливо:</label>
          <div class="form-group">
            <select
              v-model="productToTransfer"
              class="form-control"
              style="background: #effbee"
              @change="
                if (priceToTransfer != null) {
                  priceToTransfer = null;
                  validatePriceToTransfer();
                }
                productToTransferError = null;
              "
            >
              <option :value="null" disabled selected hidden>
                Выберите топливо
              </option>
              <option
                v-for="fb in getCardAccFuelBalance(currentAcc)"
                :key="fb.id"
                :value="fb.id"
              >
                {{ fb.name }}
              </option>
            </select>
            <error-p :error="productToTransferError" />
          </div>
          <label>Цена:</label>
          <div class="form-group">
            <select
              v-model="priceToTransfer"
              class="form-control"
              style="background: #effbee"
              :disabled="productToTransfer == null"
              @change="
                if (fuelRequestQuantity != null) validateFuelAccToAccModal();
                priceToTransferError = null;
              "
            >
              <option :value="null" disabled selected hidden>
                Выберите цену
              </option>
              <option
                v-for="p in getCardAccFuelPrices(currentAcc, productToTransfer)"
                :key="p"
                :value="p"
              >
                {{ p }}
              </option>
            </select>
            <error-p :error="priceToTransferError" />
          </div>
          <label>Объём, литры:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите объём"
              class="form-control"
              style="background: #effbee"
              :max="
                getCardAccFuelQuantityByPrice(
                  currentAcc,
                  productToTransfer,
                  priceToTransfer
                )
              "
              min="0"
              @input="validateFuelAccToAccModal"
              v-model="fuelRequestQuantity"
              :disabled="productToTransfer == null || priceToTransfer == null"
            />
            <error-p :error="fuelRequestQuantityError" />
          </div>
          <label
            >Доступно:
            {{
              getCardAccFuelQuantityByPrice(
                currentAcc,
                productToTransfer,
                priceToTransfer
              )
            }}
            л.</label
          >
        </template>
        <template slot="ok-title">Перевести</template>
      </modal>
      <!-- Пополнение денежного баланса -->
      <modal
        :id="moneyModalId"
        v-if="showMoneyModal"
        @close="closeMoneyModal"
        @cancel="closeMoneyModal"
        @ok="requestMoneyBalance"
      >
        <template slot="header-title">Пополнить денежный баланс</template>
        <template slot="body">
          <p>{{ modalCaption }}</p>
          <p v-if="moneyModalError" class="text-danger">
            {{ moneyModalError }}
          </p>
          <label>Сумма, {{ getCurrencyName }}:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите сумму"
              class="form-control"
              style="background: #effbee"
              min="0"
              max="999999999999"
              @input="validateMoneyModal"
              v-model="moneyRequestQuantity"
            />
          </div>
        </template>
        <template slot="ok-title">Создать заявку</template>
      </modal>
      <!-- Пополнить денежный баланс картсчёта -->
      <modal
        :id="moneyToAccModalId"
        v-if="showMoneyToAccModal"
        @close="closeMoneyToAccModal"
        @cancel="closeMoneyToAccModal"
        @ok="transferMoneyToAcc"
      >
        <template slot="header-title"
          >Пополнить денежный баланс карт-счёта</template
        >
        <template slot="body">
          <p>{{ moneyToAccCaption }}</p>
          <label>Сумма, {{ getCurrencyName }}:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите сумму"
              class="form-control"
              style="background: #effbee"
              :max="getClientMoneyBalance"
              min="0"
              v-model="moneyRequestQuantity"
              @input="validateMoneyToAccModal"
            />
            <error-p :error="moneyRequestQuantityError" />
          </div>
          <label
            >Доступно: {{ getClientMoneyBalance }} {{ getCurrencyName }}.</label
          >
        </template>
        <template slot="ok-title">Пополнить</template>
      </modal>
      <!-- Перевод на денежный баланс картсчёта -->
      <modal
        :id="moneyAccToAccModalId"
        v-if="showMoneyAccToAccModal"
        @close="closeMoneyAccToAccModal"
        @cancel="closeMoneyAccToAccModal"
        @ok="transferMoneyAccToAcc"
      >
        <template slot="header-title">Перенести денежные средства</template>
        <template slot="body">
          <p>{{ moneyAccToAccCaption }}</p>
          <label>Целевой счёт:</label>
          <div class="form-group">
            <select
              v-model="toAccId"
              class="form-control"
              style="background: #effbee"
            >
              <option :value="null" disabled selected hidden>
                Выберите счёт
              </option>
              <option v-for="ca in getOtherAccs" :key="ca.id" :value="ca.id">
                {{ ca.name }}
              </option>
            </select>
            <error-p :error="toAccIdError" />
          </div>
          <label>Сумма, {{ getCurrencyName }}:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите сумму"
              class="form-control"
              style="background: #effbee"
              :max="getCardAccMoneyBalance(currentAcc)"
              min="0"
              v-model="moneyRequestQuantity"
              @input="validateMoneyAccToAccModal"
            />
            <error-p :error="moneyRequestQuantityError" />
          </div>
          <label
            >Доступно: {{ getCardAccMoneyBalance(currentAcc) }}
            {{ getCurrencyName }}.</label
          >
        </template>
        <template slot="ok-title">Перевести</template>
      </modal>
      <!-- Заказ карт -->
      <modal
        :id="cardModalId"
        v-if="showCardModal"
        @close="closeCardModal"
        @cancel="closeCardModal"
        @ok="requestCard"
      >
        <template slot="header-title">Заказать топливные карты</template>
        <template slot="body">
          <p>{{ modalCaption }}</p>
          <label>Количество, штук:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите количество"
              class="form-control"
              style="background: #effbee"
              v-model="cardRequestQuantity"
            />
          </div>
        </template>
        <template slot="ok-title">Создать заявку</template>
      </modal>
      <!-- Заказ брелков -->
      <modal
        :id="trinketModalId"
        v-if="showTrinketModal"
        @close="closeTrinketModal"
        @cancel="closeTrinketModal"
        @ok="requestTrinket"
      >
        <template slot="header-title">Заказать топливные брелки</template>
        <template slot="body">
          <p>{{ modalCaption }}</p>
          <label>Количество, штук:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите количество"
              class="form-control"
              style="background: #effbee"
              v-model="trinketRequestQuantity"
            />
          </div>
        </template>
        <template slot="ok-title">Создать заявку</template>
      </modal>
      <!-- Блокировка карты -->
      <modal
        v-if="showBlockModal"
        @close="closeBlockModal"
        @cancel="closeBlockModal"
        @ok="blockCard"
      >
        <template slot="header-title">Подтвеждение</template>
        <template slot="body">
          <p>Нажимая ОК Вы подтверждаете блокировку топливной карты.</p>
        </template>
      </modal>
      <!-- Разлокировка карты -->
      <modal
        v-if="showUnblockModal"
        @close="closeUnblockModal"
        @cancel="closeUnblockModal"
        @ok="unblockCard"
      >
        <template slot="header-title">Подтвеждение</template>
        <template slot="body">
          <p>Нажимая ОК Вы подтверждаете разблокировку топливной карты.</p>
        </template>
      </modal>
      <!-- Создать карт-счёт -->
      <modal
        v-if="showNewAccModal"
        @close="closeNewAccModal"
        @cancel="closeNewAccModal"
        @ok="createAcc"
      >
        <template slot="header-title">Создание карт-счёта</template>
        <template slot="body">
          <p v-if="newAccError" class="text-danger">{{ newAccError }}</p>
          <label>Название:</label>
          <div class="form-group">
            <input
              type="text"
              placeholder="Введите название"
              class="form-control"
              style="background: #effbee"
              @input="validateCreateAccModal"
              v-model="newAccName"
            />
          </div>
        </template>
        <template slot="ok-title">Создать карт-счёт</template>
      </modal>
      <!-- Создать личный кабинет водителя -->
      <modal
        v-if="isShowConfirmNewDriverCabinetModal || isShowDriverCabinetModal"
        :busy="getCardUserLoginLoading"
        @close="closeConfirmNewDriverCabinetModal"
        @cancel="closeConfirmNewDriverCabinetModal"
        @ok="setCardUserAccNewPass_OR_NewCardUser"
        
        :showOkButton="!getCardUserLoginFailed"
      >
        <template v-if="isShowConfirmNewDriverCabinetModal">
          <template slot="header-title">Подтвеждение</template>
          <template slot="body">
            <p>Подтвердите создание личного кабинета держателя карты № {{ cardUserAcc.cardId }}</p>          
          </template>
          <template slot="ok-title">Создать кабинет</template>      
        </template>

        <template v-if="isShowDriverCabinetModal">
          <template slot="header-title">Данные для входа в личный кабинет держателя карты № {{ cardUserAcc.cardId }}</template>
          <template slot="body">

            <template v-if="getCardUserLoginSucceeded">              
              <label>Логин:</label>
              <div class="form-group">
                <input
                  type="text"
                  disabled="true"
                  class="form-control"
                  style="background: #effbee"
                  v-model="cardUserAcc.login"
                />
              </div>
              <label>Пароль:</label>
              <div class="form-group">
                <input
                  type="text"
                  disabled="true"
                  class="form-control"
                  style="background: #effbee"
                  v-model="cardUserAcc.password"
                />
              </div>
            </template>

            <template v-if="getCardUserLoginFailed">
              <p class="text-danger">Error: {{ driverCabinerError }}</p>
            </template>

          </template>
          <template slot="ok-title" >Сменить пароль</template>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable.vue";
import modal from "@/components/modal.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import {
  CARDS_REQUEST,
  CARDS_ACCS_REQUEST,
  CARDS_BALANCE_REQUEST,
  CARDS_CLIENT_BALANCE_REQUEST,
  CARDS_BLOCK_REQUEST,
  CARDS_UNBLOCK_REQUEST,
  CARDS_ACCS_CREATE,
  CARDS_MONEY_TO_ACC_REQUEST,
  CARDS_MONEY_ACC_TO_ACC_REQUEST,
  CARDS_FUEL_TO_ACC_REQUEST,
  CARDS_FUEL_ACC_TO_ACC_REQUEST,

  CARDS_CARD_USER_LOGIN_REQUEST,
  CARDS_NEW_CARD_USER_LOGIN_REQUEST,
} from "@/store/actions/cards";
import { REQUESTS_ADD_REQUEST } from "@/store/actions/requests";
import ValueTag from "@/components/value-tag.vue";
import ErrorP from "@/components/error-p.vue";

export default {
  name: "Cards",
  components: {
    ValueTag,
    ContentHeader,
    BillTable,
    modal,
    card,
    ErrorP,
  },
  data() {
    return {
      modalCaption:
        "После отправки запроса, система сформирует заявку. Когда заявка будет обработана, новый счет появится в разделе «Счета на оплату», а так же в области уведомлений появится сообщение о новом счете.",
      fuelToAccCaption:
        "Выберите баланс и введите объём для перевода из нераспределённых средств на карт-счёт",
      fuelAccToAccCaption:
        "Выберите счёт, на который хотите перевести топливо, затем баланс, и введите объём перевода",

      moneyToAccCaption:
        "Введите сумму для перевода из нераспределённых средств на счёт",
      moneyAccToAccCaption:
        "Выберите счёт, на который хотите перевести деньги, и введите сумму перевода",

      fuelModalId: "fuel-modal",
      showFuelModal: false,
      fuelModalError: null,

      fuelToAccModalId: "fuel-to-acc-modal",
      showFuelToAccModal: false,

      fuelAccToAccModalId: "fuel-acc-to-acc-modal",
      showFuelAccToAccModal: false,

      productToTransferError: null,
      priceToTransferError: null,
      fuelRequestQuantityError: null,
      moneyRequestQuantityError: null,
      toAccIdError: null,

      fuelRequestQuantity: null,
      productToTransfer: null,
      priceToTransfer: null,

      toAccId: null,

      moneyModalId: "money-modal",
      showMoneyModal: false,
      moneyModalError: null,

      moneyToAccModalId: "money-to-acc-modal",
      showMoneyToAccModal: false,

      moneyAccToAccModalId: "money-acc-to-acc-modal",
      showMoneyAccToAccModal: false,

      moneyRequestQuantity: null,

      cardModalId: "card-modal",
      showCardModal: false,
      cardRequestQuantity: null,

      trinketModalId: "trinket-modal",
      showTrinketModal: false,
      trinketRequestQuantity: null,

      showBlockModal: false,
      showUnblockModal: false,
      cardToBlockId: null,

      showNewAccModal: false,
      newAccName: null,
      newAccError: null,

      cardsFields: [
        {
          key: "id",
          label: "№ Карты",
        },
        {
          key: "holder_name",
          label: "Держатель",
        },
        {
          key: "card_user_login",
          label: "Логин",
        },
        {
          key: "fuel_limits",
          label: "Литровые лимиты*",
          formatter: (value, key, item) => {
            return [
              item.volume_limit.target_values.day || "-",
              item.volume_limit.target_values.week || "-",
              item.volume_limit.target_values.month || "-",
              item.volume_limit.target_values.confirm || "-",
            ].join(" / ");
          },
        },
        {
          key: "money_limits",
          label: "Денежные лимиты*",
          formatter: (value, key, item) => {
            return [
              item.money_limit.target_values.day || "-",
              item.money_limit.target_values.week || "-",
              item.money_limit.target_values.month || "-",
              item.money_limit.target_values.confirm || "-",
            ].join(" / ");
          },
        },
        {
          key: "status",
          label: "Статус",
          formatter: (value, key, item) => {
            return item.block ? "Заблокирована" : "Активна";
          },
          filterByFormatted: true,
        },
        {
          key: "actions",
          label: "Управление",
          thClass: "text-xs-center",
        },
      ],
      filter: null,
      filterOn: ["id", "holder_name", "status", "card_user_login"],

      isShowDriverCabinetModal: false,
      isShowConfirmNewDriverCabinetModal: false,
      cardUserAcc: {},
      driverCabinerError: '',
    };
  },
  computed: {
    ...mapGetters([
      "isCardAccsCreationEnabled",
      "getCurrencyName",

      "getCards",
      "getCardsCount",
      "getActiveCardsCount",
      "getBlockedCardsCount",
      "isCardsLoading",
      "isCardsFailed",
      "cardsOnceLoaded",

      "getCardsAccs",
      "getCardAccName",
      "getCardsAccsNotRemoved",
      "isCardsAccsLoading",
      "isCardsAccsFailed",
      "cardsAccsOnceLoaded",
      "getCardAccFuelBalance",
      "getCardAccFuelPrices",
      "getCardAccFuelQuantityByPrice",
      "getCardAccMoneyBalance",
      "isCardAccFuelEmpty",

      "getMoneyBalance",
      "getFuelBalances",
      "isCardsBalanceLoading",
      "isCardsBalanceFailed",
      "cardsBalancesOnceLoaded",

      "getClientMoneyBalance",
      "getClientFuelBalance",
      "getClientFuelPrices",
      "getClientFuelQuantityByPrice",
      "isCardsClientBalanceLoading",
      "isCardsClientBalanceFailed",
      "cardsClientBalanceOnceLoaded",

      "getCardUserLoginLoading",
      "getCardUserLoginFailed",
      "getCardUserLoginSucceeded"
    ]),
    moneyBalance() {
      return [
        {
          name: "Тенге",
          quantity: this.getMoneyBalance,
        },
      ];
    },
    getOtherAccs() {
      return this.getCardsAccsNotRemoved.filter(
        (ca) => ca.id != this.currentAcc
      );
    },
    currentAcc() {
      return this.$route.query.acc;
    },
  },
  methods: {
    validateNumber(value, max = null) {
      let isEmpty = value == null || value == "";

      if (isNaN(value) || isEmpty) {
        return "Введите число";
      }

      if (value <= 0) {
        return "Введите число больше ноля";
      }

      if (max != null && value > max) {
        return "Введите число меньшее или равное доступному";
      }

      return null;
    },

    //Пополнение топлива
    validateFuelModal() {
      this.fuelModalError = this.validateNumber(this.fuelRequestQuantity);
      return !this.fuelModalError;
    },
    closeFuelModal() {
      this.showFuelModal = false;
      this.fuelRequestQuantity = null;
      this.resetErrors();
    },
    requestFuelBalance() {
      if (!this.validateFuelModal()) return;

      let body = JSON.stringify({
        products: [
          {
            type: "card_fuel",
            name: "Пополнение литрового баланса топливных карт, СГ",
            quantity: this.fuelRequestQuantity,
            units: "л.",
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeFuelModal();
      });
    },

    validateProductToTransfer() {
      if (this.productToTransfer == null) {
        this.productToTransferError = "Выберите топливо";
      } else {
        this.productToTransferError = null;
      }
      return !this.productToTransferError;
    },
    validatePriceToTransfer() {
      if (this.priceToTransfer == null) {
        this.priceToTransferError = "Выберите цену";
      } else {
        this.priceToTransferError = null;
      }
      return !this.priceToTransferError;
    },
    validateToAccId() {
      if (this.toAccId == null) {
        this.toAccIdError = "Выберите счёт";
      } else {
        this.toAccIdError = null;
      }
      return !this.toAccIdError;
    },

    validateFuelToAccModal() {
      this.fuelRequestQuantityError = this.validateNumber(
        this.fuelRequestQuantity,
        this.getClientFuelQuantityByPrice(
          this.productToTransfer,
          this.priceToTransfer
        )
      );

      return (
        this.validateProductToTransfer() &
        this.validatePriceToTransfer() &
        !this.fuelRequestQuantityError
      );
    },
    closeFuelToAccModal() {
      this.showFuelToAccModal = false;
      this.fuelRequestQuantity = null;
      this.productToTransfer = null;
      this.priceToTransfer = null;
      this.resetErrors();
    },
    transferFuelToAcc() {
      if (!this.validateFuelToAccModal()) return;

      this.$store
        .dispatch(CARDS_FUEL_TO_ACC_REQUEST, {
          card_account_id: +this.currentAcc,
          product_id: this.productToTransfer,
          price: String(this.priceToTransfer),
          quantity: String(this.fuelRequestQuantity),
        })
        .then(() => {
          this.closeFuelToAccModal();
          this.reloadClientBalance();
          this.reloadBalances();
        });
    },

    validateFuelAccToAccModal() {
      this.fuelRequestQuantityError = this.validateNumber(
        this.fuelRequestQuantity,
        this.getCardAccFuelQuantityByPrice(
          this.currentAcc,
          this.productToTransfer,
          this.priceToTransfer
        )
      );

      return (
        this.validateToAccId() &
        this.validateProductToTransfer() &
        this.validatePriceToTransfer() &
        !this.fuelRequestQuantityError
      );
    },
    closeFuelAccToAccModal() {
      this.showFuelAccToAccModal = false;
      this.toAccId = null;
      this.fuelRequestQuantity = null;
      this.productToTransfer = null;
      this.priceToTransfer = null;
      this.resetErrors();
    },
    transferFuelAccToAcc() {
      if (!this.validateFuelAccToAccModal()) return;

      this.$store
        .dispatch(CARDS_FUEL_ACC_TO_ACC_REQUEST, {
          from_card_account_id: +this.currentAcc,
          card_account_id: this.toAccId,
          product_id: this.productToTransfer,
          price: String(this.priceToTransfer),
          quantity: String(this.fuelRequestQuantity),
        })
        .then(() => {
          this.closeFuelAccToAccModal();
          this.reloadBalances();
        });
    },

    validateMoneyModal() {
      this.moneyModalError = this.validateNumber(this.moneyRequestQuantity);
      return !this.moneyModalError;
    },
    closeMoneyModal() {
      this.showMoneyModal = false;
      this.moneyRequestQuantity = null;
      this.moneyModalError = null;
    },
    requestMoneyBalance() {
      if (!this.validateMoneyModal()) return;

      let body = JSON.stringify({
        products: [
          {
            type: "card_money",
            name: "Пополнение денежного баланса топливных карт",
            quantity: this.moneyRequestQuantity,
            units: "тг",
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeMoneyModal();
      });
    },

    validateMoneyToAccModal() {
      this.moneyRequestQuantityError = this.validateNumber(
        this.moneyRequestQuantity,
        this.getClientMoneyBalance
      );

      return !this.moneyRequestQuantityError;
    },
    closeMoneyToAccModal() {
      this.showMoneyToAccModal = false;
      this.moneyRequestQuantity = null;
      this.resetErrors();
    },
    transferMoneyToAcc() {
      if (!this.validateMoneyToAccModal()) return;

      this.$store
        .dispatch(CARDS_MONEY_TO_ACC_REQUEST, {
          card_account_id: +this.currentAcc,
          money: this.moneyRequestQuantity,
        })
        .then(() => {
          this.closeMoneyToAccModal();
          this.reloadClientBalance();
          this.reloadBalances();
        });
    },

    validateMoneyAccToAccModal() {
      this.moneyRequestQuantityError = this.validateNumber(
        this.moneyRequestQuantity,
        this.getCardAccMoneyBalance(this.currentAcc)
      );

      return !this.moneyRequestQuantityError & this.validateToAccId();
    },
    closeMoneyAccToAccModal() {
      this.showMoneyAccToAccModal = false;
      this.toAccId = null;
      this.moneyRequestQuantity = null;
      this.resetErrors();
    },
    transferMoneyAccToAcc() {
      if (!this.validateMoneyAccToAccModal()) return;

      this.$store
        .dispatch(CARDS_MONEY_ACC_TO_ACC_REQUEST, {
          from_card_account_id: +this.currentAcc,
          card_account_id: this.toAccId,
          money: this.moneyRequestQuantity,
        })
        .then(() => {
          this.closeMoneyAccToAccModal();
          this.reloadBalances();
        });
    },

    closeCardModal() {
      this.showCardModal = false;
      this.cardRequestQuantity = null;
    },
    requestCard() {
      let body = JSON.stringify({
        products: [
          {
            type: "cards",
            name: "Топливные карты",
            quantity: this.cardRequestQuantity,
            units: "шт.",
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeCardModal();
      });
    },

    closeTrinketModal() {
      this.showTrinketModal = false;
      this.trinketRequestQuantity = null;
    },
    requestTrinket() {
      let body = JSON.stringify({
        products: [
          {
            type: "trinkets",
            name: "Топливные брелки",
            quantity: this.trinketRequestQuantity,
            units: "шт.",
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeTrinketModal();
      });
    },

    reloadCards() {
      this.$store.dispatch(CARDS_REQUEST);
    },
    reloadCardsAccs() {
      this.$store.dispatch(CARDS_ACCS_REQUEST);
    },
    reloadBalances() {
      this.$store.dispatch(CARDS_BALANCE_REQUEST);
    },
    reloadClientBalance() {
      this.$store.dispatch(CARDS_CLIENT_BALANCE_REQUEST);
    },

    closeBlockModal() {
      this.showBlockModal = false;
    },
    blockCard() {
      this.$store
        .dispatch(CARDS_BLOCK_REQUEST, { card_id: this.cardToBlockId })
        .then(() => {
          this.closeBlockModal();
        });
    },

    closeUnblockModal() {
      this.showUnblockModal = false;
    },
    unblockCard() {
      this.$store
        .dispatch(CARDS_UNBLOCK_REQUEST, { card_id: this.cardToBlockId })
        .then(() => {
          this.closeUnblockModal();
        });
    },

    validateCreateAccModal() {
      if (this.newAccName == null || this.newAccName == "") {
        this.newAccError = "Введите название";
        return;
      }

      this.newAccError = null;
    },
    closeNewAccModal() {
      this.showNewAccModal = false;
      this.newAccName = null;
      this.newAccError = null;
    },
    createAcc() {
      let body = JSON.stringify({
        name: this.newAccName,
      });
      this.$store.dispatch(CARDS_ACCS_CREATE, { body }).then(() => {
        this.closeNewAccModal();
        this.reloadCardsAccs();
        this.reloadBalances();
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetErrors() {
      this.fuelModalError = null;
      this.productToTransferError = null;
      this.priceToTransferError = null;
      this.fuelRequestQuantityError = null;
      this.moneyRequestQuantityError = null;
      this.toAccIdError = null;
    },

    showConfirmNewCabinetModal( cardId, cardUserId ) {
      if (cardUserId == null) {
        this.isShowConfirmNewDriverCabinetModal = true;  
        this.cardUserAcc = {id: cardUserId, cardId: cardId};
      }
      console.log( cardUserId );
    },

    closeConfirmNewDriverCabinetModal() {
      this.isShowConfirmNewDriverCabinetModal = false;
      this.isShowDriverCabinetModal = false;
      this.cardUserAcc = {};
    },

    showDriverCabinetModal(cardId, cardUserId) {
      console.log( 'Driver Cabinet ' + cardUserId + '  ' + cardId);
      this.$store
        .dispatch(CARDS_CARD_USER_LOGIN_REQUEST, { id: cardUserId })
        .then(( resp ) => {
          console.log( resp.data );
          this.isShowDriverCabinetModal = true;  
          this.cardUserAcc = Object.assign({id: cardUserId, cardId: cardId},  resp.data );
        });
    },

    setCardUserAccNewPass_OR_NewCardUser() {
      console.log('setCardUserAccNewPass ' + this.cardUserAcc.cardId);
      if (!this.cardUserAcc.login)
      {
        this.$store
          .dispatch(CARDS_NEW_CARD_USER_LOGIN_REQUEST, { card_id: this.cardUserAcc.cardId })
          .then(( resp ) => {
            console.log( resp.data );
            this.cardUserAcc = Object.assign(this.cardUserAcc,  resp.data );
            this.$store.dispatch(CARDS_REQUEST);
          })
          .catch( err => {
            let e = err.response.data;
            console.log(e);
            this.driverCabinerError = e.error;
          })
          .finally( () => {
            this.isShowConfirmNewDriverCabinetModal = false;
            this.isShowDriverCabinetModal = true;
          } ) ;
      }
      else // new pass
      ;

    },


  },
  beforeMount() {
    // use this component's unique client-side Vue ID
    this.fuelModalId = `fuel-modal-${this._uid}`;
    this.moneyModalId = `money-modal-${this._uid}`;
    this.cardModalId = `card-modal-${this._uid}`;
    this.trinketModalId = `trinket-modal-${this._uid}`;
  },
  created() {
    if (!this.cardsOnceLoaded) this.$store.dispatch(CARDS_REQUEST);
    if (!this.cardsAccsOnceLoaded) this.$store.dispatch(CARDS_ACCS_REQUEST);
    if (!this.cardsBalancesOnceLoaded)
      this.$store.dispatch(CARDS_BALANCE_REQUEST);
    if (!this.cardsClientBalanceOnceLoaded)
      this.$store.dispatch(CARDS_CLIENT_BALANCE_REQUEST);
  },
};
</script>